/**
 * Surveys Page Wrapper
 * 
 * Routes to V1 or V2 surveys list based on event version.
 */

import React from 'react';
import { useEventContext } from '../../contexts/EventContext';
import { useEventDetails } from '../../../hooks/useEventDetails';
import { SurveysPageV1 } from '../../v1/pages/SurveysPageV1';

export const SurveysPageWrapper: React.FC = () => {
  const { eventSlug } = useEventContext();
  const { data: eventDetails } = useEventDetails(eventSlug);
  
  // Debug logging
  console.log('[SurveysPageWrapper] Event details:', { 
    eventDetails,
    'eventDetails?.isV1Event': eventDetails?.isV1Event,
    eventSlug
  });
  
  // Check if this is a V1 event
  const isV1Event = eventDetails?.isV1Event === true;
  
  console.log('[SurveysPageWrapper] isV1Event:', isV1Event);
  
  if (isV1Event) {
    return <SurveysPageV1 />;
  }
  
  // V2 events don't have a surveys list page yet
  // They go directly to individual surveys
  return (
    <div className="min-h-screen bg-gray-50 px-4 py-8">
      <div className="max-w-4xl mx-auto text-center">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">Surveys</h2>
        <p className="text-gray-600">Survey list is not available for this event.</p>
      </div>
    </div>
  );
};